import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';

import { appointmentApiQuery } from '../../mockQuery';

import { Hospital, ListRequest, AppointmentListResponse } from './types';

const tagTypes = ['Appointment'];

export const appointmentApi = createApi({
  tagTypes,
  reducerPath: 'appointmentApi',
  baseQuery: appointmentApiQuery,
  endpoints: (build) => ({
    list: build.query<Hospital[], ListRequest>({
      providesTags: tagTypes,
      transformResponse: (response: AppointmentListResponse) => response.data,
      query: (data) => ({
        data,
        method: 'get',
        url: URL.APPOINTMENT_LIST,
      }),
    }),
  }),
});

export const { useListQuery } = appointmentApi;
